const environment = {};

const  location                     = window.location;
environment.isLocalhost             = (location.hostname === 'localhost');
environment.isDevelopment           = ((location.href.indexOf('in001vs0034') >= 0));
environment.isTest                  = ((location.href.indexOf('tandc.lab') >= 0));
environment.isProduction            = ((location.href.indexOf('tand.apps') >= 0));
environment.profiling               = (environment.isLocalhost && false);

const getServer = () => {
  if (environment.isLocalhost) {
    return {
      ssl     : '',
      domain  : 'localhost',
      port    : ':4000',
      vdir    : '',
      cors    : true,
      api     : 'api'
    };
  }

  var pathname = location.pathname.split('/');
  var vdir     = '';

  for (var i = 0; i < pathname.length - 1; i++) {
    vdir += pathname[i];
  }

  if (vdir !== '') {
    vdir += '/';
  }

  return {
    ssl     : (location.protocol === 'https:') ? 's' : '',
    domain  : location.hostname,
    port    : (location.port === '') ? '' : ':' + parseInt(location.port, 10),
    vdir    : vdir,
    cors    : false,
    api     : 'api'
  };
}

environment.server = getServer();

export default environment;